// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3qDDH","placeholdersHeader":"styles_placeholdersHeader__1Fa-E","editorStyle":"styles_editorStyle__1_IXu","placeholdersBox":"styles_placeholdersBox__1qp00"};